interface titleInterface {
    value: number;
    description: string;
}

export const reviewAuditJobGridColumns: Function = (titleArray: Array<titleInterface>): Array<Object> => {
    return [
        {
            field: "Location",
            title: titleArray[0].description,
            width: "200px",
            wmsid: 1,
            filterable: true,
        },
        {
            field: "Customer",
            title: titleArray[1].description,
            width: "200px",
            wmsid: 1,
            filterable: true,
        },
        {
            field: "MovableUnit",
            title: titleArray[2].description,
            width: "200px",
            wmsid: 1,
            filterable: true,
        },
        {
            field: "ItemName",
            title: titleArray[3].description,
            width: "200px",
            wmsid: 1,
            filterable: true,
            template: function (dataItem) {
                return `<label> ${dataItem.title.replace(/,/g, "</br> &nbsp;&nbsp;&nbsp;&nbsp; ")}</label>`;
            },
        },
        {
            field: "SystemQty",
            title: titleArray[4].description,
            width: "200px",
            wmsid: 2,
            filterable: true,
        },
        {
            field: "AllocatedQty",
            title: titleArray[5].description,
            width: "200px",
            wmsid: 3,
            filterable: true,
        },
        {
            field: "CountedQty",
            title: titleArray[6].description,
            width: "200px",
            wmsid: 4,
            filterable: true,
        },
        {
            field: "Variance",
            template: function (dataItem: any) {
                const color = dataItem.Variance === 0 ? "black" : "red";
                return `<span style="color: ${color};">${dataItem.Variance}</span>`;
            },
            title: titleArray[7].description,
            width: "200px",
            wmsid: 5,
            filterable: true,
        },
    ];
};

export const reviewAuditJobGridSchema: Function = (): Object => {
    return {
        model: {
            id: "id",
            fields: {
                Location: {
                    type: "string",
                },
                Customer: {
                    type: "string",
                },
                MovableUnit: {
                    type: "string",
                },
                ItemName: {
                    type: "string",
                },
                SystemQty: {
                    type: "number",
                },
                AllocatedQty: {
                    type: "number",
                },
                CountedQty: {
                    type: "string",
                },
                Variance: {
                    type: "number",
                },
            },
        },
    };
};
